import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "@emotion/styled";
import { updateRoadmapDelivery } from "state/roadmapsCompanion/actions";
import { faHandPointer, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { selectIsRoadmapsLoading } from "state/roadmapsCompanion/selectors";
import useCompanion from "app/companion/useCompanion";
import ClientSmsModal from "app/companion/pages/delivery/ClientSmsModal";
import {
  canSendClientSms,
  getNextDeliveryToWarn,
} from "app/companion/pages/delivery/clientSms";

const DeliveryConfirmButton = () => {
  const dispatch = useDispatch();
  const { filteredDelivery: delivery, filteredRoadmap: roadmap } = useCompanion();
  const isLoading = useSelector((state) => selectIsRoadmapsLoading(state));
  const [isDelivered, setIsDelivered] = useState(delivery?.done);
  // Arrêt suivant figé au moment de la confirmation : la tournée se rafraîchit pendant
  // que la fenêtre est ouverte, le destinataire ne doit pas changer sous les doigts.
  const [smsTarget, setSmsTarget] = useState(null);

  useEffect(() => {
    if (delivery) {
      setIsDelivered(delivery.done);
    }
  }, [delivery]);

  const toggleDeliveryStatus = async () => {
    const wasDelivered = isDelivered;
    await dispatch(updateRoadmapDelivery(delivery.id, { done: !wasDelivered }));

    // On annule un arrêt : rien à proposer.
    if (wasDelivered) return;

    // Arrêt confirmé — livraison comme récupération : le livreur repart vers le prochain
    // client à livrer, on lui propose de le prévenir. Seules les récupérations ne
    // reçoivent pas ce SMS ; confirmer une récupération peut donc très bien annoncer la
    // livraison qui la suit. Si ce client a déjà été prévenu, canSendClientSms l'écarte.
    // Facultatif — la confirmation est déjà enregistrée, fermer la fenêtre sans envoyer
    // ne remet rien en cause.
    const next = getNextDeliveryToWarn(roadmap, delivery);
    if (canSendClientSms(next)) {
      setSmsTarget(next);
    }
  };

  if (!delivery) return null;

  return (
    <>
      <FixedBottom>
        <Button
          disabled={isLoading}
          variant={isDelivered ? "danger" : "success"}
          block
          onClick={toggleDeliveryStatus}
          style={{ borderRadius: 0, padding: '0.8rem', fontSize: '1rem' }}
        >
          {isLoading ? (
            <>
              <FontAwesomeIcon icon={faSpinner} pulse /> Enregistrement ...
            </>
          ) : isDelivered ? (
            <>
              <FontAwesomeIcon icon={faHandPointer} />{" "}
              {delivery.recovery ? "Annuler la récupération" : "Annuler la livraison"}
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faHandPointer} />{" "}
              {delivery.recovery ? "Confirmer la récupération" : "Confirmer la livraison"}
            </>
          )}
        </Button>
      </FixedBottom>

      <ClientSmsModal
        show={Boolean(smsTarget)}
        onClose={() => setSmsTarget(null)}
        roadmapDelivery={smsTarget}
        title="Prévenir le client suivant"
      />
    </>
  );
};

const FixedBottom = styled.div`
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0 0.5rem;
`;

export default DeliveryConfirmButton;
